import React from "react";

export type PageSupportFooterProps = {
  context?: string;
  topic?: string;
  centered?: boolean;
  className?: string;
};

export default function SupportFooter({
  context,
  topic,
  centered = false,
  className = "",
}: PageSupportFooterProps) {
  const resolvedTopic =
    (topic ?? context ?? "your payroll workspace").trim();

  return (
    <p
      className={[
        centered ? "text-center" : "",
        "text-xs text-gray-500",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      Need help with {resolvedTopic}?{" "}
      <a
        href="mailto:info@paycalcutility.com"
        className="font-medium text-brand-vault hover:underline"
      >
        Talk to us.
      </a>
    </p>
  );
}